<template>
    <li
        class="nav-item dropdown"
        @click="toggleDropDown"
        v-click-outside="closeDropdown"
        ref="notifications"
    >
        <span class="nav-link cursor-pointer">
            <div>
                <i class="ni ni-bell-55" :style="{color: color.secondary}"></i>
                <span
                    v-if="notificationCount && notificationCount.notRead > 0"
                    class="nch--badge">
                </span>
            </div>
        </span>
        <div
            v-if="loaded"
            class="dropdown-menu py-0 overflow-hidden"
            :class="[
                {show: isOpen},
                {'dropdown-menu-right': direction},
                {'dropdown-menu-xl': !mobile}
            ]"
        >
            <!-- Dropdown header -->
            <div class="px-3 py-3 justify-content-between justify-content-sm-center dropdown">
                <div class="info-config-header row col-10 col-sm-12">
                    <h6 class="col-12 col-sm-7 mb-3 mb-sm-0 text-sm text-muted m-0">
                        {{$t('header.notifications.you_have')}}
                        <strong
                            :style="{'color': color.primary}"
                            class="text-primary"
                        >{{ notificationCount ? notificationCount.notRead : 0 }}</strong>
                        {{ (notificationCount && notificationCount.notRead) > 1 ?
                            $t('header.notifications.notifications') :
                            $t('header.notifications.notification') }}
                    </h6>
                    <BaseButton
                        v-if="(notificationCount && notificationCount.notRead)"
                        outline
                        type="secondary"
                        size="sm"
                        class="col-12 col-sm-5 text-muted rounded-pill"
                        @click="markAllRead($event)"
                    >
                        {{ $t('header.notifications.marker_all_read') }}
                    </BaseButton>
                </div>
                <i v-if="mobile" @click="closeDropdown($event)" class="col-2 fa fa-times"></i>
            </div>
            <!-- List group -->
            <div
                id="list-notifications"
                class="list-group list-group-flush scrolling-dropdown"
                @click="$event => $event.stopPropagation()"
            >
                <div v-for="notification in notifications.data" :key="notification.id"
                    :id="`notification-${notification.id}`"
                    :class="notification.read ? '' : 'nch--read'"
                    class="d-flex list-group-item align-items-start mark-animation m200"
                >
                    <a
                        @click="redirectToLesson(notification.id, notification.planId, notification.lessonId)"
                        class="col-10 col-sm-11 list-group-item-action"
                    >
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <span :style="{'color': notification.settings.color}">
                                    <i :class="checkIcon(notification.type)" class="mdi ni-2x"></i>
                                </span>
                            </div>
                            <div class="col ml--2">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4
                                            class="mb-0 text-sm"
                                        >{{notification.translation.name}}</h4>
                                    </div>
                                </div>
                                <p class="text-sm mb-0">{{notification.translation.body}}</p>
                                <!-- Escolhe a formatação da data baseado na linguagem -->
                                <p
                                    class="text-sm mb-0 text-lg-right text-left text-muted"
                                >
                                    {{$moment(notification.created).format(dateFormat)}}
                                </p>
                            </div>
                        </div>
                    </a>
                    <div
                        class="col-1 col-sm-1 cursor-pointer d-flex align-items-start"
                        @click.prevent="markRead(notification.id, $event, true)"
                    >
                        <i class="mdi mdi-close-circle-outline nch--size-mark px-0"></i>
                    </div>
                </div>
            </div>
            <!-- View all -->
            <a
                href="/app/notifications"
                :style="{'color': '#515E7E'}"
                class="dropdown-item text-center font-weight-bold py-3"
            >{{$t('header.notifications.all')}}</a>
        </div>
        <div
            v-else
            class="dropdown-menu dropdown-menu-xl py-0 overflow-hidden"
            :class="[{show: isOpen}, {'dropdown-menu-right': direction}]"
        >
            <Loading />
        </div>
    </li>
</template>

<script>
import BaseButton from '../../argon/components/BaseButton';
import Loading from '../Common/LoadingSpinner';

export default {
    name: 'NotificationsMenu',
    data() {
        return {
            isOpen: false,
            loaded: false,
            notificationList: [],
            pageNotificationList: 1,
            verifyMarkRead: false,
        };
    },
    components: {
        BaseButton,
        Loading,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        notificationCount: Object,
        user: Object,
        mobile: Boolean,
    },

    watch: {
        isOpen(newValue) {
            if (newValue === true) {
                const observer = new MutationObserver(this.reloadNotificationList);
                observer.observe(this.$refs.notifications, {
                    childList: true,
                    subtree: true,
                });
            }
        },
    },

    computed: {
        direction() {
            return !this.$store.getters.NAVBAR_POSITION;
        },

        notifications() {
            return this.$store.getters.LOADED_NOTIFICATIONS_NOT_READ;
        },

        currentLanguage() {
            return localStorage.getItem('lang');
        },

        dateFormat() {
            switch (this.currentLanguage) {
                case 'pt-BR':
                    return 'HH:mm DD/MM/YYYY';
                case 'en':
                    return 'HH:mm MM/DD/YYYY';
                default:
                    return 'HH:mm DD/MM/YYYY';
            }
        },
    },
    methods: {
        getDataFromApi() {
            const data = this.$store
                .dispatch('LOAD_NOTIFICATIONS', {
                    page: this.pageNotificationList,
                    order: 'ASC',
                    per_page: 9,
                    column: 'read',
                    user_id: this.user.id,
                });
            return data;
        },

        async redirectToLesson(notificationId, planId, lessonId) {
            await this.markRead(notificationId);

            if (lessonId) {
                return window.axios
                    .get(`/api/plan/${planId}/redirect/lesson/${lessonId}`)
                    .then((res) => {
                        if (res.data.redirectLink === '') {
                            window.location.href = '/app/plan/'+ planId + res.data.originalLink;
                        } else {
                            window.location.href = '/app/plan/'+ planId + res.data.redirectLink;
                        }
                    })
                    .catch(err => err);
            }

            // Caso não tenha id da aula, significa que não existe uma aula dentro do
            // módulo que foi vinculado ao plano, então redireciona para o plano
            window.location.href = '/app/plan/'+ planId;
        },

        async markRead(id, event, justMark = false) {
            if (justMark) {
                event.stopPropagation();
                this.verifyMarkRead = true;
                document.getElementById(`notification-${id}`).classList.add('mark-animation-active');
                await this.$store.dispatch('SET_NOTIFICATION_READ', id)
                    .then((resp) => {
                        if (resp.status === 200) {
                            this.notificationCount.notRead -= 1;
                            this.getDataFromApi();
                        }
                    })
                    .catch(() => document.getElementById(`notification-${id}`).classList.remove('mark-animation-active'))
                    .finally(() => {
                        this.verifyMarkRead = false;
                    });
            } else {
                this.$store.dispatch('SET_NOTIFICATION_READ', id);
            }
        },

        toggleDropDown() {
            if (window.location.pathname !== '/app/notifications') {
                if (!this.isOpen && this.pageNotificationList === 1) {
                    this.getDataFromApi()
                        .then(() => {
                            this.loaded = true;
                        });
                }
                this.isOpen = !this.isOpen;
            }
        },

        closeDropdown(event) {
            event.stopPropagation();
            this.isOpen = false;
            this.loaded = false;
            this.pageNotificationList = 1;
            this.$emit('change', false);
        },
        checkIcon(type) {
            switch (type) {
            case 'APP_TICKET_REPLY':
                return 'mdi-ticket-confirmation';
            default:
                return 'mdi-alert-circle-outline';
            }
        },

        reloadNotificationList() {
            const elementScroll = document.querySelector('#list-notifications');
            if (elementScroll) {
                elementScroll.addEventListener('scroll', () => {
                    if (!this.verifyMarkRead) {
                        const position = elementScroll.scrollTop;
                        const endOfPage = elementScroll.scrollHeight - elementScroll.clientHeight;

                        if (position === endOfPage &&
                            this.notifications.meta.last_page > this.pageNotificationList) {
                            this.pageNotificationList += 1;
                            this.getDataFromApi();
                        }
                    }
                });
            }
        },

        markAllRead(event) {
            event.stopPropagation();
            this.$store.dispatch('SET_NOTIFICATION_READ_ALL', this.user.id);
            this.notificationCount.notRead = 0;
            this.getDataFromApi();
            this.closeDropdown(event);
        },
    },
};
</script>

<style scoped>
.nch--read {
    background: #edf2fa;
}
.nch--read:hover {
    background: #f7f9fd;
}
.nch--badge {
    left: 25px;
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
}
.nch--circle {
    width: 50px;
    height: 50px;
}
.dropdown{
    display: flex;
    align-items: center;
}
.m200{
    min-width: 300px;
}
.scrolling-dropdown {
    max-height: 500px;
    overflow-y: auto;
}
.nch--size-mark {
    font-size: 20px;
}
.mark-animation {
    opacity: 1;
    transition: opacity 0.15s;
}
.mark-animation-active {
    opacity: 0;
}
.info-config-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

</style>
